import React from 'react'
import clsx from 'clsx'
import {Link,useNavigate} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  id?: any
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  id
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config;
  const active = {
    color: "#fff",
    backgroundColor: "#F06445",
  };
  const navigate = useNavigate();
  const navigateToPage = ()=>{
    navigate(to);
  }
  //const icons = 'fa-print';
  
  return (
    <div className='menu-item' >
      <div  className={clsx('menu-link without-sub ', {active: isActive})} onClick={navigateToPage}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon me-2'>
             {/* <KTSVG path={icon} className='svg-icon svg-icon-5' /> */}
            {/* <img src={icon} className='svg-icon svg-icon-1' style={{width:'23px'}}/> */}
            <i className={clsx('fas fs-5', icon)}></i>
    
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-6', fontIcon)}></i>}
        <span className='menu-title '>{title}</span>
      </div>
      {children}
    </div>
  )
}

export {AsideMenuItem}
